import { Card } from '@tag/tag-components-react-v4';

export default Card;
